import React, { useEffect, useContext } from "react";
import HostSidebar from "./HostSidebar";
import HostHeader from "./HostHeader";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { messaging, getToken } from "../../../firebase";
import { saveFcmToken } from "../../../services/AuthService";
import { ThemeContext } from "../../../context/ThemeContext";
import { NavMenuToggle } from "../../layouts/nav/NavHader";


const HostIndexMain = () => {
  const { menuToggle, sidebariconHover } = useContext(ThemeContext);
  // Notification Setup
  const { auth } = useSelector((state) => state.auth);

  useEffect(() => {
    const setupNotifications = async () => {
      // 1. Try Redux first, then LocalStorage (since login.jsx saves to LS but might not update Redux)
      let currentUser = auth;

      if (!currentUser || !currentUser._id) {
        const stored = localStorage.getItem("hostDetails");
        if (stored) {
          try {
            currentUser = JSON.parse(stored);
            console.log("🔔 Recovered Host from LocalStorage:", currentUser);
          } catch (e) {
            console.error("Failed to parse hostDetails", e);
          }
        }
      }

      console.log("🔔 Final Auth Object:", currentUser);

      // 2. Check if user is logged in
      if (!currentUser || !currentUser._id) {
        console.log("⚠️ No Host ID found. Notification setup skipped.");
        return;
      }

      try {
        console.log("🔔 Requesting notification permission...");
        const permission = await Notification.requestPermission();

        if (permission === "granted") {
          console.log("✅ Notification permission granted.");

          // 3. Get Token
          const token = await getToken(messaging, {
            vapidKey: "BMwaf27rSCa8456dekPjTC5fcFljCr-x0NzBHnosuM9V3rLNHIyFztfcAMLcASlUFagvw0d9UVpBzdo4S01pjRA"
          });

          if (token) {
            // console.log("🔥 FCM Token:", token);
            // 4. Save to Backend
            // Use _id from the MongoDB host object
            const hostId = currentUser._id;
            await saveFcmToken(hostId, token);
            console.log(`💾 FCM Token saved to server for Host: ${hostId}`);
          }
        }
      } catch (error) {
        console.error("❌ Notification setup failed:", error);
      }
    };

    setupNotifications();
  }, [auth]);

  return (
    <div
      id="main-wrapper"
      className={`show ${sidebariconHover ? "iconhover-toggle" : ""} ${menuToggle ? "menu-toggle" : ""} d-flex host-layout`}
      style={{ height: "100vh" }}
    >
      <div
        className="sidebar-overlay-active"
        onClick={() => NavMenuToggle()}
      />
      <HostSidebar />
      <div className="flex-grow-1 d-flex flex-column" style={{ minHeight: 0 }}>
        <HostHeader />
        <main
          className="px-4 py-3"
          style={{
            height: "90%", // << Set exact height here
            overflow: "auto",
          }}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );

};

export default HostIndexMain;
